import { render } from "./sysUserShowTemp.vue?vue&type=template&id=10ae5234"
import script from "./sysUserShowTemp.vue?vue&type=script&lang=js"
export * from "./sysUserShowTemp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__